import campaign from './campaign.vue'

export default campaign
